const FONT_H = { fontFamily: "'Outfit', sans-serif" };
const FONT_B = { fontFamily: "'Manrope', sans-serif" };
const PRIMARY = '#6C3CE0';

function AuthInput({ label, type = 'text', value, onChange, testId, required }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5" style={FONT_B}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} required={required}
        className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm bg-white focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 outline-none transition-all"
        style={FONT_B} data-testid={testId} />
    </div>
  );
}

export function ForgotPasswordView({ email, setEmail, loading, onSubmit, sent, onBackToLogin }) {
  return (
    <div data-testid="auth-forgot-view">
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-2 text-gray-900" style={FONT_H}>Reset your password</h1>
      <p className="text-gray-500 text-sm mb-8" style={FONT_B}>
        {sent ? 'Check your email for a reset link.' : "Enter your email and we'll send you a reset link."}
      </p>
      {!sent ? (
        <form onSubmit={onSubmit} className="space-y-4">
          <AuthInput label="Email" type="email" value={email} onChange={setEmail} testId="auth-forgot-email" required />
          <button type="submit" disabled={loading}
            className="w-full rounded-xl font-bold py-3.5 text-white text-sm transition-all hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ ...FONT_B, backgroundColor: PRIMARY }} data-testid="auth-forgot-submit">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
      ) : (
        <div className="bg-purple-50 border border-purple-200 rounded-xl p-4 text-sm text-purple-700 mb-4" data-testid="auth-forgot-success">
          If an account exists with that email, you&apos;ll receive a password reset link shortly.
        </div>
      )}
      <button onClick={onBackToLogin} className="mt-4 text-sm font-semibold hover:underline" style={{ color: PRIMARY }} data-testid="auth-forgot-back">
        Back to sign in
      </button>
    </div>
  );
}
